import React, { useState } from 'react';
import { Popover } from 'antd';

import Icon from 'components/mweb/Icon/Icon';

import './multiple-sku-drop-down.scss';

const MultipleSkuDropDown = ({
  product = {},
  sku = {},
  containerStyle = 'sku-main--product-quantity-container',
  quantityTextStyle = 'sku-main--product-sku-textstyle',
  productSubTextStyle = 'sku-main--product-sub-textstyle',
  IconSize = 14,
  activeSkuIndex = 0,
  rightArrow = false,
  setActiveSkuIndex = () => {},
}) => {
  const [clicked, setClicked] = useState(false);
  const hasMultipleSku = product?.skus?.length > 1;

  const content = (
    <>
      {product?.skus.map((sku, index) => {
        const activeSku = activeSkuIndex === index;
        return (
          <div
            className="drop-down--wrapper"
            onClick={() => setActiveSkuIndex(index)}
          >
            <div>
              <span className="drop-down--quantity-style">{sku?.quantity}</span>
              {sku?.subText && (
                <span className="drop-down--subtext-style">{sku?.subText}</span>
              )}
            </div>
            {activeSku && (
              <div className="drop-down--icon-container">
                <Icon class="icon-subscription-tick" size={16} />
              </div>
            )}
          </div>
        );
      })}
    </>
  );

  return (
    <Popover
      placement="bottom"
      content={content}
      trigger="click"
      arrowColor="transparent"
      overlayClassName="multiple-sku-drop-down"
      visible={clicked}
      onVisibleChange={visible => {
        const openSkuPopup = product?.skus?.length > 1;
        if (openSkuPopup) setClicked(visible);
      }}
    >
      <div
        className={`${containerStyle} ${
          !hasMultipleSku ? 'single-sku-drop-down' : ''
        }`}
      >
        <div>
          <span className={quantityTextStyle}>{sku?.quantity}</span>
          {sku?.subText && (
            <span className={productSubTextStyle}>{sku?.subText}</span>
          )}
        </div>
        {hasMultipleSku && (
          <div className="sku-main--icon-container">
            <Icon
              class={`icon-multiple-sku-dropdown ${
                rightArrow ? 'drop-down--right-arrow' : ''
              }`}
              size={IconSize}
            />
          </div>
        )}
      </div>
    </Popover>
  );
};

export default MultipleSkuDropDown;
